module.exports = __webpack_public_path__ + "static/media/joey-1920.50285303.png";